import MiBreadcrumbs from './MiBreadcrumbs.vue'

export default MiBreadcrumbs
